import AxisView from 'molbio/maps/circular/AxisView';
import {
  HomologyAwareFragmentResultData,
  getHomologyAwareFragmentResultData,
} from 'molbio/maps/circular/HomologyUtil';

export default class HomologyRegionAxisView extends AxisView {
  static initClass(): void {
    this.prototype.className = 'homologyRegionAxis';
  }

  getPiecesData(): Array<HomologyAwareFragmentResultData> | null {
    return getHomologyAwareFragmentResultData(this._sequence, this.getOuterRadius(), (basePair: number) =>
      this.basePairToAngle(basePair)
    );
  }
}

HomologyRegionAxisView.initClass();
